import script from "./ExecutiveInscriptionMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ExecutiveInscriptionMain.vue?vue&type=script&setup=true&lang=js"

import "./ExecutiveInscriptionMain.vue?vue&type=style&index=0&id=40bac634&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bac634"]])

export default __exports__